import { Component, OnInit, HostListener } from "@angular/core";
import { MatDialogRef } from "@angular/material";

@Component({
  selector: "app-ks-info-modal",
  templateUrl: "./ks-info-modal.component.html",
  styleUrls: ["./ks-info-modal.component.scss"]
})
export class KsInfoModalComponent implements OnInit {
  constructor(public dialog: MatDialogRef<KsInfoModalComponent>,) {}

  ngOnInit() {

  }

  @HostListener('window:keydown', ['$event'])
    hotkeyDown($event) {
        if (
            $event.keyCode === 27 ) {
            this.dialog.close();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/ks-info-modal/ks-info-modal.component.ts